import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
		min: 'error.required',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
});

export const CaseViewDamageRequisitionerSchema = yup.object().shape({
	damageLocation: yup.string().required(),

	damageCause: yup.string().required().min(1),

	damageDate: yup.date().required(),
	//damageDate: yup.date().transform((val, original) => original === "" ? undefined : val),

	damageDescription: yup.string(),

	requisitionerName: yup.string().required(),

	requisitionerPhone: yup.string().when('requisitionerName', {
		is: (requisitionerName: string) => requisitionerName === 'Scalepoint',
		then: yup.string(),
		otherwise: yup.string().required(),
	}),

	requisitionerNoEmail: yup.boolean(),

	requisitionerEmail: yup.string().email(),

	requisitionerRelation: yup.string(),
});
